import { createAnalyticsStore } from "@/store/Analytic/create-chart-store";

export const useSentimentStatDynamicBlocksStore = createAnalyticsStore(
  "sentimentStatDynamicBlocks",
  "Analytics/rubric/sentiment/new/:projectId",
  { loadStatType: "sentiment" }
);